ticket.ticketEditModule = {
     /**
     *
     * Funkcia sluzi na zaktivnenie editacie tiketu na tiketovej sluzbe
     */
    editTicket: function() {
        try {
            main.userAction();

            if (stored.OriginalInputTicket.PlaceBetID && stored.OriginalInputTicket.PlaceBetTicketCode && stored.OriginalInputTicket.SportBoxTicketGUID) {
                var placeBetID = stored.OriginalInputTicket.PlaceBetID;
                var placeBetTicketCode = stored.OriginalInputTicket.PlaceBetTicketCode;
                var placeBetTicketGUID = stored.OriginalInputTicket.SportBoxTicketGUID;
                main.closeDialog();
                modal.showLoading();
                var requestUrl;
                $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/edit/SBID_" + stored.SBID + "/" + placeBetID + "/" + placeBetTicketCode)
                .done(function (data) {
                    if (data.Errors && !data.Errors.length && data.IsEdited) {
                        main.createLog(3, "CentralTicketEdit", "# PLACEBETID: " + placeBetID + " # TICKETCODE: " + placeBetTicketCode + " # GUID: " + ticket.anonymGuid(placeBetTicketGUID));
                        ticket.ticketEditModule.editTicketSubscription(placeBetTicketCode, "ADD", placeBetTicketGUID, data);
                    } else {
                        main.createLog(2, "CentralTicketEdit_ERROR", "# PLACEBETID: " + placeBetID + " # TICKETCODE: " + placeBetTicketCode + " # GUID: " + ticket.anonymGuid(placeBetTicketGUID) + " # ISEDITED: " + data.IsEdited + " # ERROR: " + data.Errors);
                        var errors = modal.parseErrors(data.Errors);
                        modal.showErrObj(2, 5, {errObj: errors});
                        ticket.ticketWsRetrieve();
                        return false;
                    }
                })
                .fail(function (jqXHR) {
                    jqXHR.requestUrl = requestUrl;
                    main.createLog(2, "CentralTicketEdit_Failed", "# PLACEBETID: " + placeBetID + " # TICKETCODE: " + placeBetTicketCode + " # GUID: " + ticket.anonymGuid(placeBetTicketGUID) + " # AJAX FAILED: " + JSON.stringify(jqXHR));
                    modal.showErrObj(2, 5, {err1: texts.TicketEditInfo, err2: texts.ConnectionErr, errType: "default"});
                    return false;
                })
                .always(function () {
                    // Odznaci pripadne oznacene oddy v zapasoch dna
                    $("#sportBox .content-table .ui-btn-up-e").removeClass("ui-btn-up-e");
                    modal.hideLoading();
                });
                return true;
            } else if (stored.OriginalInputTicket) {
                main.createLog(2, "CentralTicketEdit_ERROR", "GUID: " , "# PLACEBETID: " + placeBetID + " # TICKETCODE: " + placeBetTicketCode + " # GUID: " + ticket.anonymGuid(placeBetTicketGUID) + " # ERROR: missing parameter");
            }  else {
                main.createLog(2, "CentralTicketEdit_ERROR", " # ERROR: missing parameter");
            }
            ticket.ticketWsRetrieve();
            return false;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            ticket.ticketWsRetrieve();
            return false;
        }
    },

    /**
     *
     * Funkcia na subscribe zmien tykajucich sa oddov pri editacii tiketu
     *
     * @param ticketCode    ticket code podaneho tiketu na editovanie
     * @param operation     "ADD" - subscribe, "REM" - unsubscribe
     * @param ticketGUID    GUID podaneho tiketu na editovanie (sluzi len na logovanie)
     */
    editTicketSubscription: function(ticketCode, operation, ticketGUID, data) {
        try {
            main.userAction();
            if (ticketCode && operation) {
                var requestUrl;
                $.getJSON(requestUrl = url.ticket + "ticketsubscription/" + ticketCode + "/" + operation)
                .done(function (result) {
                    if (result === true) {
                        if (operation === "ADD") {
                            ticket.state.setState({isEditTicket: data.IsEdited});
                            ticket.ticketTypeSwitch(data.TYPE, !ticket.state.isTicketWsType(data.TYPE));
                            ticket.ticketRender(data);
                        } else if (operation === "REM") {
                            ticket.state.setState({isEditTicket: false});
                            ticket.ticketWsReset(true);
                        }
                    }
                    main.createLog(3, "CentralTicketEditSubscription", "GUID: " + ticket.anonymGuid(ticketGUID) + " # OPERATION: " + operation + " # RESULT: " + result);
                    return false;
                })
                .fail(function (jqXHR) {
                    jqXHR.requestUrl = requestUrl;
                    main.createLog(2, "CentralTicketEditSubscription_Failed", "GUID: " + ticket.anonymGuid(ticketGUID) + " # OPERATION: " + operation + " # AJAX FAILED: " + JSON.stringify(jqXHR));
                    modal.showErrObj(2, 5, {err1: texts.TicketEditInfo, err2: texts.ConnectionErr, errType: "default"});
                    return false;
                })
                return true;
            } else {
                main.createLog(2, "CentralTicketEditSubscription_ERROR", "GUID: " + ticket.anonymGuid(ticketGUID) + " # ERROR: missing parameter");
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            ticket.ticketWsRetrieve();
            return false;
        }
    },

    // Oznacenie oddu pre buduci odkup pri editacii tiketu
    oddBuyBackCheckBoxAction: function(ticketGUID, oddID) {
        try {
            main.userAction();
            main.lockSbmButtons();
            main.createLog(2, "oddBuyBackCheckBoxAction", "GUID: " + ticket.anonymGuid(ticketGUID));
            $("#freebetList, #bonificationList").hide();
            if (oddID) {
                if (player.playerSettingsModule.userSettingCheckboxTrigger("oddBuyBack" + oddID)) {
                    ticket.ticketEditModule.oddBuyBack(oddID);
                } else {
                    ticket.ticketEditModule.oddBuyBackReset(oddID);
                }
            }
        } catch (e) {
            main.unlockSbmButtons();
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    /**
     *
     * Funkcia na nastavenie oddu ako odkupovaneho pocas editacie tiketu
     *
     * @param oddID    id oddu na odkup
     */
    oddBuyBack: function(oddID) {
        try {
            var requestUrl;
            $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/oddbuyback/" + oddID)
            .done(function (data) {
                if (data.Errors && !data.Errors.length) {
                    ticket.ticket(data, null, true, true);
                } else {
                    main.createLog(2, "CentralTicketOddBuyBack_ERROR", "ODD: " + oddID + " # ERROR: " + data.Errors);
                    var errors = modal.parseErrors(data.Errors);
                    modal.showErrObj(2, 5, {errObj: errors});
                    ticket.ticketWsRetrieve();
                    return false;
                }
            })
            .fail(function (jqXHR) {
                jqXHR.requestUrl = requestUrl;
                main.createLog(2, "CentralTicketOddBuyBack_Failed", "ODD: " + oddID + " # AJAX FAILED: " + JSON.stringify(jqXHR));
                modal.showErrObj(2, 5, {err1: texts.TicketEditInfo, err2: texts.ConnectionErr, errType: "default"});
                ticket.ticketWsRetrieve();
                return false;
            })
            .always(function () {
                main.unlockSbmButtons();
            });
            return true;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            ticket.ticketWsRetrieve();
            return false;
        }
    },

    /**
     *
     * Funkcia na nastavenie oddu ako neodkupovaneho pocas editacie tiketu
     *
     * @param oddID    id oddu na zrusenie odkupu
     */
    oddBuyBackReset: function(oddID) {
        try {
            var requestUrl;
            $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/oddbuybackreset/" + oddID)
            .done(function (data) {
                if (data.Errors && !data.Errors.length) {
                    ticket.ticket(data, null, true, true);
                } else {
                    main.createLog(2, "CentralTicketOddBuyBackReset_ERROR", "ODD: " + oddID + " # ERROR: " + data.Errors);
                    var errors = modal.parseErrors(data.Errors);
                    modal.showErrObj(2, 5, {errObj: errors});
                    return false;
                }
            })
            .fail(function (jqXHR) {
                jqXHR.requestUrl = requestUrl;
                main.createLog(2, "CentralTicketOddBuyBackReset_Failed", "ODD: " + oddID + " # AJAX FAILED: " + JSON.stringify(jqXHR));
                modal.showErrObj(2, 5, {err1: texts.TicketEditInfo, err2: texts.ConnectionErr, errType: "default"});
                ticket.ticketWsRetrieve();
                return false;
            })
            .always(function () {
                main.unlockSbmButtons();
            });
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            ticket.ticketWsRetrieve();
            return false;
        }
    },

    /**
     *
     * Funkcia sluzi na zmenu zobrazenia "rozrobeneho tiketu" do "editacneho modu" a naopak
     *
     * @param editMode    true - zobrazenie s editaciou, false - standard zobrazenie rozrobeny tiket
     * @param ticketCode  identifikator ticketCode pre zobrazenie tiketu
     */
    prepareTicketForEdit: function(editMode, ticketCode) {
        try {
            if (editMode) {
                // Z pohladu zobrazenia pri editacii tiketu je tiket v zobrazeni JT
                if (ticketCode) {
                    ticket.state.setState({isEditTicket: true, type: ticket.state.ticketWsTypes.JT});

                    $("#ticketTabs").hide();
                    $("#ticketForEdit").find("#ticketForEditCancelButton").attr("onmousedown", "ticket.ticketEditModule.editTicketSubscription('" + ticketCode + "', 'REM')")
                        .end().find("#ticketForEditCodeTicketCode").html(ticketCode)
                        .end().show();
                    $("#betInfo").addClass("ui-disabled");
                    // Animacia s modrym pozadim
                    if (!$("#ticket").hasClass("edit-mode")) {
                        $("#ticket, #submitTicket").removeClass("submit-mode").addClass("edit-mode");
                        $("#ticket").addClass("highlight-edit-mode").delay(2000).queue(function(){
                            $(this).removeClass("highlight-edit-mode");
                            $(this).dequeue();
                         });
                    }
                    return true;
                }
                return false;
            } else {
                ticket.ticketPromoModule.freebetBonificationShowButtons();
                $("#ticketForEdit, #ticketForEditInfo").hide();
                $("#ticketForEditCancelButton").removeAttr("onmousedown");
                $("#betInfo").removeClass("ui-disabled");
                $("#ticket, #submitTicket").removeClass("edit-mode").addClass("submit-mode");
                $("#ticketTabs").show();
                return true;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    /**
     *
     * Funkcia sluzi na zistenie moznosti akcii pri editacii tiketu
     *
     * @param action            pozadovana akcia
     * @param ticketIsEdited    priznak ci sa jedna o editovany tiket
     * @param odd               Object s oddom z ticketWS
     */
    isOddAvailableForAction: function(action, ticketIsEdited, odd) {
        try {
            switch (action) {
                case "remove":
                    if (!ticketIsEdited || (ticketIsEdited && !odd.IsRemoveForbiden && !(odd.IsWinning === 'BB') && (odd.IsRemoveable || !odd.IsEditedOdd))) {
                        return true;
                    }
                    break;
                case "buyback":
                    if (ticketIsEdited && (ticket.ticketEditModule.showOddBuyback(odd) || odd.IsWinning === 'BB') && !ticket.ticketEditModule.isOddAlreadyBoughtBack(odd)) {
                        return true;
                    }
                    break;
                default:
                    return false;
            }
            return false;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi na zistenie ci odd na tikete ma byt zobrazeny ako odkupovy
    showOddBuyback: function(odd) {
        try {
            if (odd) {
                return (
                    (odd.IsWinning === 'BB' && !odd.IsEditedEvaluated) ||
                    (odd.BuyBackValue && odd.BuyBackValue > -1 && (odd.IsWinning === 'BB' || (!odd.IsRemoveForbiden && odd.BuyBackValue && odd.BuyBackValue > 0 && !odd.IsRemoveable)))
                  );
            }
            return false;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi na zistenie ci odd na tikete bol odkupeny
    isOddAlreadyBoughtBack: function(odd) {
        try {
            if (odd) {
                return odd.IsWinning === 'BB' && odd.IsEditedEvaluated;
            }
            return false;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi na update tiketu v stave editacie
    oddBuyBackChanged: function(oddsID, oddsRate, buyBackValue, isRemovable) {
        try {
            if (oddsID && (oddBB = $("#ticket #" + oddsID))) {
                if (oddBB.length) {
                    // Nejdeny odd
                    if (oddBB.hasClass("odd-buyback-evaluated") && oddBB.find("#crsBuyback").text() != buyBackValue) {
                        // Ak je oznaceny na odkup a zmenil odkupovy kurz, nastane reload
                        rfs.buyBackReloadTicket = clearTimeout(rfs.buyBackReloadTicket);
                        delete rfs.buyBackReloadTicket;
                        rfs.buyBackReloadTicket = setTimeout(function() {
                            service.loadPure("ticket");
                        }, 2000);
                    } else {
                        // Aktualizuje odkupovy kurz
                         if (buyBackValue) {
                            var arrow = "";
                            var tRate = $(oddBB.find("#crsBuyback")).text();
                            if (tRate != buyBackValue) {
                                // Porovna deltu s kurzom na tikete a aktualizuje ho
                                if (tRate > buyBackValue) {
                                    arrow = "ArrD";
                                } else if (tRate < buyBackValue) {
                                    arrow = "ArrU";
                                }
                                // Aktualizuje kurz a prida sipku
                                oddBB.find("#crsBuyback").text(buyBackValue.toFixed(2)).removeClass().addClass(arrow);

                                // Zhasne sipku po urcitom case
                                events.eventsSignalrModule.hideArrow("T_" + oddsID, "#ticketList #" + oddsID, "#crsBuyback");
                            }
                        }
                        var oddFound = odds.find(function (odd) {
                            if (odd.OddID === oddsID) {
                                odd.BuyBackValue = buyBackValue;
                                odd.IsRemoveable = isRemovable;
                                odd.IsRemoveForbiden = odd.IsRemoveForbiden? odd.IsRemoveForbiden: isRemovable;
                                odd.Rate = oddsRate;
                                return odd;
                            }
                        });
                        if (isRemovable) {
                            // Ak je odd odstranitelny, tak prida moznost odstranenia oddu
                            oddBB.removeClass("odd-non-removable").find(".ui-list-text").removeClass("ui-disabled");
                        } else {
                            // Odd nieje odstranitelny
                            oddBB.addClass("odd-non-removable");
                        }
                        if (buyBackValue > 0 && (typeof oddFound === 'object') && ticket.ticketEditModule.isOddAvailableForAction("buyback", stored.TicketEditActive, oddFound)) {
                            oddBB.addClass("odd-buybackable");
                        }
                        if (!isRemovable && !oddBB.hasClass("odd-buybackable")) {
                            // Neodkupitelny odd disabluje
                            oddBB.find(".ui-list-text").addClass("ui-disabled");
                        }
                    }
                    return true;
                }
            }
            return false;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    }
};
